module.exports = __webpack_public_path__ + "static/media/ci.728ba64d.svg";